"use strict";

angular.module("vendor")
.controller("SectionProductsList", function($rootScope, $scope, UserService, SupplierUserInfoService) {
    this.updateViewSelected = function(view) {
        SupplierUserInfoService.updateVendorProductViewSelected(view);
    };

    UserService.refreshCurrentUser().then(function(user) {
        if (user && user.info) {
            $scope.currentView = user.info.vendor_product_view_selected;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-list.controller.js
// module id = 983
// module chunks = 0